// extracted by mini-css-extract-plugin
export default {"ctn":"id_ctn__YFHnX","colorChangeButton":"id_colorChangeButton__kLQZj","textBox":"id_textBox__ERn8f"};